import { AppState } from '../../types';
import { GuideValues, StudioViewPositions, StudioMode } from '../../../configs/studio';

export const selectIsOpen = (state: AppState): boolean => state.studio.isOpen;

export const selectIsOpenSettingsPanel = (state: AppState): boolean => state.studio.isOpenSettingsPanel;

export const selectIsSupportUserMedia = (state: AppState): boolean => state.studio.isSupportUserMedia;

export const selectIsSupportUserAudio = (state: AppState): boolean => state.studio.isSupportUserAudio;

export const selectGuide = (state: AppState): GuideValues => state.studio.guide;

export const selectText = (state: AppState): string => state.studio.text;

export const selectIsAutoScrolling = (state: AppState): boolean => state.studio.isAutoScrolling;

export const selectAutoScrollAudioService = (state: AppState): boolean => state.studio.autoScrollAudioService;

export const selectIsRunningAudioService = (state: AppState): boolean => state.studio.isRunningAudioService;

export const selectIsConnectingAudioService = (state: AppState): boolean => state.studio.isConnectingAudioService;

export const selectScrollSpeed = (state: AppState): number => state.studio.scrollSpeed;

export const selectFontSize = (state: AppState): number => state.studio.fontSize;

export const selectMediaNotAvailableStatus = (state: AppState): boolean => state.studio.mediaNotAvailable;

export const selectScrollIntervalId = (state: AppState): number | null => state.studio.scrollIntervalId;

export const selectBookmarkPosition = (state: AppState): number | null => state.studio.bookmarkPosition;

export const selectAverageCalibrateLevel = (state: AppState): number => state.studio.averageCalibrateVolume;

export const selectIsCalibratingAudioService = (state: AppState): boolean => state.studio.isCalibratingAudioService;

export const selectMainContainerHeight = (state: AppState): number => state.studio.mainContainerHeight;

export const selectHomeAction = (state: AppState): boolean => state.studio.homeAction;

export const selectBookmarkAction = (state: AppState): boolean => state.studio.bookmarkAction;

export const selectIsPlayPrompter = (state: AppState): boolean => state.studio.isPlayPrompter;

export const selectIsCountdown = (state: AppState): boolean => state.studio.isCountdown;

export const selectCurrentCountdown = (state: AppState): number => state.studio.currentCountdown;

export const selectStartDelayTime = (state: AppState): number => state.studio.startDelayTime;

export const selectIsSelectDropdownOpen = (state: AppState): boolean => state.studio.isSelectDropdownOpen;

export const selectStudioMode = (state: AppState): StudioMode => state.studio.studioMode;

export const selectCameraRecording = (state: AppState): boolean => state.studio.isCameraRecording;

export const selectStudioTopView = (state: AppState): StudioViewPositions => state.studio.studioTopView;

export const selectStudioBottomView = (state: AppState): StudioViewPositions => state.studio.studioBottomView;

export const selectStudioRecordCount = (state: AppState): number => state.studio.recordCount;

export const selectCountdownCamera = (state: AppState): boolean => state.studio.isCountdownCamera;

export const selectCameraId = (state: AppState): string => state.studio.cameraId;

export const selectTeleprompterSync = (state: AppState): boolean => state.studio.isTeleprompterSync;

export const selectCameraReady = (state: AppState): boolean => state.studio.cameraReady;

export const selectCameraError = (state: AppState): boolean => state.studio.cameraError;

export const selectAudioId = (state: AppState): string => state.studio.audioId;
